import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BackendReadyContext = createContext(false);

export function BackendReadyProvider({ children }) {
  const [backendReady, setBackendReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    let attempts = 0;
    const MAX_ATTEMPTS = 10; // ~10 seconds max
    const INTERVAL_MS = 1000;

    async function checkHealth() {
      try {
        await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/actuator/health`,
          {
            timeout: 2000,
          },
        );
        if (mounted) {
          setBackendReady(true);
        }
        return true;
      } catch {
        return false;
      }
    }

    async function poll() {
      const ok = await checkHealth();
      if (ok || !mounted) return;

      const interval = setInterval(async () => {
        attempts++;
        const ok = await checkHealth();
        if (ok || attempts >= MAX_ATTEMPTS) {
          clearInterval(interval);
          // If we exhausted retries, let the user try anyway
          if (!ok && mounted) {
            console.warn(
              "Backend health check failed after max attempts, allowing user actions",
            );
            setBackendReady(true);
          }
        }
      }, INTERVAL_MS);
    }

    poll();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <BackendReadyContext.Provider value={backendReady}>
      {children}
    </BackendReadyContext.Provider>
  );
}

export function useBackendReady() {
  return useContext(BackendReadyContext);
}
